import script from "./TariffCodeDetailView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TariffCodeDetailView.vue?vue&type=script&setup=true&lang=ts"

import "./TariffCodeDetailView.vue?vue&type=style&index=0&id=7532bf27&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7532bf27"]])

export default __exports__